module.exports = __webpack_public_path__ + "static/media/sy.96bb3c22.svg";